import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const WarningIcon = createIcon({
  displayName: 'WarningIcon',
  path: [
    <path
      d='M4.95203 16.3536L10.215 5.85659C10.9529 4.38482 13.0537 4.38521 13.7911 5.85724L19.0493 16.3543C19.7154 17.6841 18.7485 19.25 17.2611 19.25H6.7399C5.25217 19.25 4.28523 17.6835 4.95203 16.3536Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M12 10.0001V12.0001'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z'
      fill='currentColor'
    />
  ],
  defaultProps: defaultProps
})
